import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  paymentAccounts: [],
  dataPaging: {},
};

const slice = createSlice({
  name: 'payment-account',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getPaymentAccounts(state, action) {
      state.isLoading = false;
      state.paymentAccounts = action.payload;
    },

    getDataPaging(state, action) {
      state.isLoading = false;
      state.dataPaging = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getPaymentAccounts(queryParams) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('account-payments', {
        params: queryParams,
      });
      const { paymentAccounts } = response?.data?.data || [];

      let newPaymentAccounts = paymentAccounts;
      if (newPaymentAccounts?.per_page) {
        newPaymentAccounts = newPaymentAccounts.data;
      }

      dispatch(slice.actions.getPaymentAccounts(newPaymentAccounts));
      dispatch(slice.actions.getDataPaging(paymentAccounts));
    } catch (error) {
      console.error('error ', error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
